import { SessionOverviewPanel } from '../SessionOverviewPanel/SessionOverviewPanel';

export const SessionOverviewEmpty = ({ children }: { children: React.ReactNode }) => (
  <SessionOverviewPanel>
    <p className='text-text-default-secondary'>{children}</p>
  </SessionOverviewPanel>
);
